<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：学校资源库  >  <router-link to="/paper_video" class="cl_gray">视频库</router-link>  >  上传视频</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="video_upload">
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark mat5"><span class="cl_red">*</span>上传视频</div>
						<div class="video_upload_item_r">
							<el-upload class="found_l_item_file" action="http://res.joy366.com/api/upload/post_add_viedo" :data="data" :on-remove="handleRemove"
							 :limit="1" :on-exceed="handleExceed" :on-success="handleAvatarSuccess" accept=".mp4" :file-list="fileList">
							  <el-button size="small" class="found_l_item_file_btn">点击上传</el-button>
							  <div slot="tip" class="f14px cl_gray mat10">仅支持mp4，且上传文件大小不能超过2GB</div>
							</el-upload>
						</div>
					</div>
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark mat10"><span class="cl_red">*</span>视频名称</div>
						<div class="video_upload_item_r">
							<input type="text" placeholder="请输入视频名称" v-model="name" class="f16px video_upload_item_input" />
						</div>
					</div>
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark mat5"><span class="cl_red">*</span>简介</div>
						<div class="video_upload_item_r">
							<textarea placeholder="请输入相关简介" v-model="intro" class="f16px video_upload_item_area"></textarea>
						</div>
					</div>
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark mat5"><span class="cl_red">*</span>所属学科</div>
						<div class="video_upload_item_r">
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray cl_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectId==subject_cur}"
								 @click="subjectCheck(item.subjectId)">{{item.subjectName}}</span>
							</div>
						</div>
					</div>
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark mat5"><span class="cl_red">*</span>适用年级</div>
						<div class="video_upload_item_r">
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray cl_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur}"
								 @click="gradeCheck(item.gradeId)">{{item.gradeName}}</span>
							</div>
						</div>
					</div>
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark mat10"><span class="cl_red">*</span>关联知识点</div>
						<div class="video_upload_item_r">
							<div class="video_upload_item_kn">
								<input type="text" placeholder="请选择知识点" v-model="knowledge_basic_name" class="f16px video_upload_item_input" disabled />
								<button class="f18px cl_violet" @click="dialog_show=true">选择知识点</button>
							</div>
						</div>
					</div>
					<div class="video_upload_item">
						<div class="video_upload_item_l f16px cl_dark"><span class="cl_red">*</span>可见范围</div>
						<div class="video_upload_item_r">
							<label class="f18px cl_gray mar15">
								<input type="radio" v-model="who_can_see" value="self" class="mar10" />
								<span>仅自己可见</span>
							</label>
							<label class="f18px cl_gray mal15">
								<input type="radio" v-model="who_can_see" value="all" class="mar10" />
								<span>全校可见</span>
							</label>
						</div>
					</div>
					<div class="video_upload_item mat50">
						<div class="video_upload_item_l f16px cl_dark mat10"></div>
						<div class="video_upload_item_r">
							<button class="video_upload_submit f18px cl_white" @click="submit">提交视频</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 选择知识点 -->
		<el-dialog title="选择关联知识点" :visible.sync="dialog_show" width="40%" center>
		  <div class="f16px video_dialog">
				<div class="famous_screen_list">
					<el-select v-model="material_cur" placeholder="全部" @change="materialSelect">
						<el-option v-for="item in material":key="item.Id" :label="item.Name":value="item.Id"></el-option>
					</el-select>
				</div>
				<div class="task_video_nav radius8 mat20 cl_dark" v-if="chapter.length > 0">
					<div class="task_nav_first mab20" v-for="(item,index) in chapter" :key="index">
						<div class="task_nav_first_title f16px cur" @click="firstOpen(index)" :class="{'on':item.open}">
							<img src="../../../static/select_right.png" class="mar5" />
							<span>{{item.gradeName}}</span>
						</div>
						<div class="task_nav_second mat10" v-for="(second,secondIndex) in item.chapter_data" :key="secondIndex" v-if="item.open">
							<div class="task_nav_second_title cur" @click="secondOpen(index,secondIndex)" :class="{'on':second.open}">
								<img src="../../../static/select_right.png" class="mar5" />
								<span class="clip">{{second.chapter}}</span>
							</div>
							<div class="task_nav_three" v-if="second.open">
								<div class="task_nav_three_title clip mat10 cur" v-for="(three,index) in second.section_knowledge_data" :key="index"
								 :class="{'on':three.knowledgeId == knowledge_basic_id}" @click="knowledgeCheck(three.knowledgeId, three.knowledgeName)">{{three.unit}} {{three.knowledgeName}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 创建成功 -->
		<el-dialog title="" :visible.sync="success_show" width="25%" center :closeOnClickModal="false">
			<div class="f16px paper_dialog_cont tc">
				<img src="../../../static/success_green.png" />
				<p class="f20px cl_gray mat10">视频提交成功！</p>
			</div>
			<div slot="footer" class="f18px mab20">
				<router-link to="/video_my" replace class="cl_violet cur inline paper_dialog_cancel">查看视频</router-link>
				<span @click="successReturn" class="cl_violet cur inline paper_dialog_cancel">继续上传</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 6,
					listCur: 1,
					open: 0,
				},
				subject: [], //学科
				subject_cur: "",
				grade: [], //年级
				grade_cur: "",
				fileList: [], //上传视频
				url: "",
				data: {
					token: localStorage.getItem("token")
				},
				name: "", //名称
				intro: "", //简介
				knowledge_basic_id: "", //知识点
				knowledge_basic_name: "",
				who_can_see: "all", //可见范围；all所有人self自己
				dialog_show: false,
				material: [], //教材
				material_cur: "",
				chapter: [], //章节
				chapter_cur: "",
				success_show: false,
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getGrade();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//视频上传
			handleRemove(file, fileList) {
				this.url = "";
			},
			handleExceed(files, fileList) {
				this.$message.warning("最多只能上传一个文件");
			},
			handleAvatarSuccess (response, file, fileList) {
				this.url = response.data.file;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectId;
					this.getMaterial();
				});
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.getMaterial();
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0].gradeId;
				});
			},
			gradeCheck (e) {
				this.grade_cur = e;
			},
			//教材
			getMaterial () {
				this.$get("/api/teacher/get_subject_chapter_edition_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
				})
				.then(res => {
					this.material = res.data;
					this.material_cur = this.material[0].Id;
					this.getChapter();
				});
			},
			materialSelect (e) {
				this.getChapter();
			},
			//章节
			getChapter () {
				this.$get("/api/teacher/get_chapter_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
					edition_id: this.material_cur,
				})
				.then(res => {
					this.chapter = [];
					this.knowledge_basic_id = "";
					if (res.data.length > 0) {
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].open = false;
							if (res.data[i].chapter_data.length > 0) {
								for (let j = 0; j < res.data[i].chapter_data.length; j++) {
									res.data[i].chapter_data[j].open = false;
								}
							}
						}
						this.chapter = res.data;
					}
				});
			},
			firstOpen (e) {
				if (this.chapter[e].open) {
					this.chapter[e].open = false;
				} else {
					this.chapter[e].open = true;
				}
			},
			secondOpen (index,secondIndex) {
				if (this.chapter[index].chapter_data[secondIndex].open) {
					this.chapter[index].chapter_data[secondIndex].open = false;
				} else {
					this.chapter[index].chapter_data[secondIndex].open = true;
				}
			},
			knowledgeCheck (id, knowledgeName) {
				this.knowledge_basic_id = id;
				this.knowledge_basic_name = knowledgeName;
				this.dialog_show = false;
			},
			//提交
			submit () {
				if (this.name == "") {
					this.$message({
						duration: 1500,
						message: '视频名称不能为空',
						type: 'error'
					});
					return false
				}
				if (this.intro == "") {
					this.$message({
						duration: 1500,
						message: '视频简介不能为空',
						type: 'error'
					});
					return false
				}
				if (this.knowledge_basic_id == "") {
					this.$message({
						duration: 1500,
						message: '关联知识点不能为空',
						type: 'error'
					});
					return false
				}
				if (this.url == "") {
					this.$message({
						duration: 1500,
						message: '视频文件不能为空',
						type: 'error'
					});
					return false
				}
				this.$get("/api/teacher/post_examination_video_add",{
					token: localStorage.getItem("token"),
					name: this.name,
					intro: this.intro,
					who_can_see: this.who_can_see,
					url: this.url,
					subject_id: this.subject_cur,
					grade_id_str: this.grade_cur,
					knowledge_basic_id: this.knowledge_basic_id,
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					this.success_show = true;
				});
			},
			successReturn () {
				this.success_show = false;
				location.reload();
			},
		},
	}
</script>

<style>
</style>
